import React from 'react';
import * as styles from './styles.css';
import Disclaimer from './disclaimer';
import FooterBottomLineLinks from './footer-bottom-line-links';

export interface IFooterProps {
  id?: string;
}

const current_year = new Date().getFullYear();

const Footer = ({ id }: IFooterProps) => {
  const [showDisclaimer, setShowDisclaimer] = React.useState(false);

  function handleClickDisclaimer() {
    setShowDisclaimer(!showDisclaimer);
  }

  return (
    <div id={id} className={styles.footer}>
      <div className={styles.footerStaticText}>
        Varsity Tutors © 2007-{current_year}. All Rights Reserved.{' '}
      </div>
      <FooterBottomLineLinks
        onClickDisclaimer={handleClickDisclaimer}
        disclaimerActive={showDisclaimer}
      />
      {showDisclaimer && <Disclaimer />}
    </div>
  );
};

export default Footer;
